import CommonState from '@/class/cargo/model/parameters/CommonState'

export const ASSETS = new CommonState(1, '资产', 'Assets')
export const CURRENTASSETS = new CommonState(11, '流动资产', 'Currentassets')
export const NONCURRENTASSETS = new CommonState(12, '非流动资产', 'Noncurrentassets')
export const LIABILITY = new CommonState(2, '负债', 'Liability')
export const CURRENTLIABILITY = new CommonState(21, '流动负债', 'Currentliability')
export const NONCURRENTLIABILITY = new CommonState(22, '非流动负债', 'Noncurrentliability')
export const EQUITY = new CommonState(3, '权益', 'Equity')
export const OWNERSEQUITY = new CommonState(31, '所有者权益', 'Owners equity')
export const COST = new CommonState(4, '成本', 'Cost')
export const COST2 = new CommonState(41, '成本', 'Cost2')
export const INTEREST = new CommonState(5, '损益', 'Interest')
export const REVENUE = new CommonState(51, '营业收入', 'Revenue')
export const OTHERREVENUE = new CommonState(52, '其他收益', 'Other revenue')
export const EXPENSE = new CommonState(53, '期间费用', 'Expense')
export const LOSSES = new CommonState(54, '其他损失', 'Losses')
export const COSTANDTAXES = new CommonState(55, '营业成本及税金', 'Cost and taxes')
export const ADJUSTINTEREST = new CommonState(56, '以前年度损益调整', 'Adjust interest')
export const INCOMETAX = new CommonState(57, '所得税', 'Incometax')
export const ACCOUNT_TITLE_TYPE = [
  ASSETS,
  CURRENTASSETS,
  NONCURRENTASSETS,
  LIABILITY,
  CURRENTLIABILITY,
  NONCURRENTLIABILITY,
  EQUITY,
  OWNERSEQUITY,
  COST,
  COST2,
  INTEREST,
  REVENUE,
  OTHERREVENUE,
  EXPENSE,
  LOSSES,
  COSTANDTAXES,
  ADJUSTINTEREST,
  INCOMETAX
]
